import React, { useCallback, useEffect, useState } from "react";
import Banner2 from "../components/Banner2";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  computeVehicleValidationFlags,
  formatToDDMMYYYY,
  getDaysDiff,
  getExcelDate,
  getISOFormattedDate,
  isTodayOrPast,
  setVehicleInformation,
} from "../utils/commonHelper";
import { NoData } from "../components/common/NoData";
import {
  getAoMasterData,
  getCountryDetail,
  getLicenseVehicle,
  getPlateTypeDetails,
  getProductDetail,
  getTravelProductType,
  addTransactionData,
  resetVehicleData,
} from "../features/product";
import { DynamicFormModal } from "../components/common/dynamic-form-modal";
import { useTranslation } from "react-i18next";
import { createProductInquiry } from "../features/productInquiry";
import {
  createPeopleArrayFromGroups,
  getYearDifferenceFromToday,
} from "../utils/gigHelpers";
import {
  createTakafulPeopleArrayFromGroups,
  getClaimDetails,
  prepareTakafulMotorPremiumCalInputs,
} from "../utils/takafulHelpers";
import { prepareOqicQuoteData } from "../utils/oqicHelpers";
import { addDays, differenceInDays, parse } from "date-fns";
import { Loader } from "../components/common/loader";
import VehicleValuationForm from "../components/VehicleValuationForm";
import { ProductParameterForm } from "../components/ProductParameterForm";
import AlertDialog from "../components/common/AlertDialog";
import Stepper from "../components/Stepper";
import heroImage from "../assets/images/new_image.png";
import travelMain from "../assets/images/travel_main.jpg";
import "../components/css/MotorPage-mobile.css";


const MotorPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const productDetails = localStorage.getItem("product_details")
    ? JSON.parse(localStorage.getItem("product_details"))
    : null;

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [subProducts, setSubProducts] = useState([]);
  const [product, setProduct] = useState({});
  const [platTypeArray, setPlatTypeArray] = useState([]);
  const [firstTime, setFirstTime] = useState(false);
  const [previousInsuranceExpired, setPreviousInsuranceExpired] =
    useState(false);
  const [licenceExpired, setLicenceExpired] = useState(false);
  const [previousThirdPartyInsurance, setPreviousThirdPartyInsurance] =
    useState(false);
  const [vehicleAgeLimitExpired, setVehicleAgeLimitExpired] = useState(false);
  const [policyHas60Days, setPolicyHas60Days] = useState(false);
  const [showValidationAlert, setShowValidationAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ title: "", message: "" });
  const selectedProduct = JSON.parse(localStorage.getItem("product_details"));
  const [errors, setErrors] = useState({});
  const {
    products,
    productDetail,
    productLoader,
    productDetailLoader,
    countryDetails,
    travelProductType,
    aoMasterDataLoader,
    fetchingVehicleDataLoader,
    vehicleData,
  } = useSelector((state) => state.product);
  // console.log(vehicleData, 'vehicleData')
  const [formData, setFormData] = useState({
    licence_no: "",
    plate_no: "",
    plate_char: "",
    start_date: addDays(new Date(), 1),
    end_date: addDays(new Date(), 2),
  });
  const [askMemberDetailForm, setAskMemberDetailForm] = useState(false);
  const [activeSubProduct, setActiveSubProduct] = useState(null);
  const [selectedVehicleDescription, setSelectedVehicleDescription] =
    useState(null);
  const [loadingVehicleSection, setLoadingVehicleSection] = useState(false);
  const [vehicleFetched, setVehicleFetched] = useState(false);
  const [showVehicleSection, setShowVehicleSection] = useState(false);

  const { productInquiryLoader, productInquiry } = useSelector(
    (state) => state.productInquiry
  );

  const adults = Number(formData?.["no_of_adults_-_(age_18_or_above)"] || 0);
  const children = Number(formData?.["no_of_child_-_(age_16_or_below)"] || 0);
  const seniors = Number(formData?.["no_of_seniors_-_(age_71_to_79)"] || 0);

  const disableSenior = adults > 0 || children > 0;
  const disableAdultsAndChildren = seniors > 0;
  const isArabic = i18n.language?.startsWith("ar");
  const askMemberDetailFormData = [
    {
      input_label: "Member First Name",
      input_type: "text",
      is_mandatory: "1",
    },
    {
      input_label: "Member Last Name",
      input_type: "text",
      is_mandatory: "1",
    },
    {
      input_label: "Member Dob",
      input_type: "date",
      is_mandatory: "1",
    },
    {
      input_label: "Member Pass Num",
      input_type: "text",
      is_mandatory: "1",
    },
    {
      input_label: "Member Gender",
      input_type: "select",
      is_mandatory: "1",
      option_paremeter: [
        {
          option_label: "Male",
          option_value: "Male",
        },
        {
          option_label: "Female",
          option_value: "Female",
        },
        {
          option_label: "Other",
          option_value: "Other",
        },
      ],
    },
    {
      input_label: "Civil Residence Num",
      input_type: "text",
      is_mandatory: "1",
    },
    {
      input_label: "Nationality",
      input_type: "text",
      is_mandatory: "1",
    },
    {
      input_label: "Passenger Type",
      input_type: "select",
      is_mandatory: "1",
      option_paremeter: [
        {
          option_label: "Adult",
          option_value: "ADT",
        },
        {
          option_label: "Child",
          option_value: "CHD",
        },
        {
          option_label: "Senior",
          option_value: "SNR",
        },
      ],
    },
  ];

  const handleSubProductClick = useCallback(
    (data, index) => {
      localStorage.setItem("product_details", JSON.stringify(data));
      setActiveSubProduct(index);
      setFormData((prev) => ({
        ...prev, // ✅ keep existing values
        start_date: prev.start_date ?? addDays(new Date(), 1),
        end_date: prev.end_date ?? addDays(new Date(), 2),
      }));
      dispatch(getProductDetail(data));
    },
    [dispatch]
  ); // include only what you actually use from outside

  useEffect(() => {
    dispatch(resetVehicleData());
    setSelectedVehicleDescription(null);
  }, [activeSubProduct]);

  useEffect(() => {
    const vehicleDesc =
      vehicleData?.ropVehicle?.Body
        ?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult
        ?.result
        ?.vehicle_description
        ?.Vehicle_Description;

    // ✅ Handle both object and array
    const hasVehicleDescriptions = Array.isArray(vehicleDesc)
      ? vehicleDesc.length > 0
      : vehicleDesc != null && typeof vehicleDesc === "object";

    if (hasVehicleDescriptions) {
      setShowVehicleSection(true);
    }
  }, [vehicleData]);


  useEffect(() => {
    const subProductLoc = JSON.parse(localStorage.getItem("product_details"));

    const productTemp = products.find(
      (p) => p.id === subProductLoc?.product_id
    );

    setProduct(productTemp);

    if (
      productTemp &&
      productTemp.sub_products &&
      productTemp.sub_products.length > 0
    ) {
      setSubProducts(productTemp.sub_products);

      // Check if this is motor product (id: 1)
      if (productTemp.id === 1) {
        // Find Comprehensive sub-product (id: 21)
        const comprehensiveSubProduct = productTemp.sub_products.find(
          (subProduct) => subProduct.id === 21
        );

        if (comprehensiveSubProduct) {
          // Find the index of Comprehensive sub-product for activeSubProduct state
          const comprehensiveIndex = productTemp.sub_products.findIndex(
            (subProduct) => subProduct.id === 21
          );

          setActiveSubProduct(comprehensiveIndex);
          handleSubProductClick(
            {
              product_id: comprehensiveSubProduct.product_id,
              sub_product_id: comprehensiveSubProduct.id,
            },
            comprehensiveIndex
          );
        } else {
          // Fallback to first sub-product if Comprehensive not found
          setActiveSubProduct(0);
          handleSubProductClick(
            {
              product_id: productTemp.sub_products[0]?.product_id,
              sub_product_id: productTemp.sub_products[0]?.id,
            },
            0
          );
        }
      } else {
        // For non-motor products, keep existing logic (select first sub-product)
        if (productTemp.sub_products.length > 0) {
          setActiveSubProduct(0);
          handleSubProductClick(
            {
              product_id: productTemp.sub_products[0]?.product_id,
              sub_product_id: productTemp.sub_products[0]?.id,
            },
            0
          );
        }
      }
    }
  }, [products, handleSubProductClick]);

  const submitGetQuote = async (e) => {

    e.preventDefault();
    // return

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // if (productDetail && productDetail.has_company && productDetail.has_company === false) { :: remove condition to send all inquiry (motor,travel)
    dispatch(
      createProductInquiry({
        form_data: formData,
        product_details: JSON.parse(localStorage.getItem("product_details")),
      })
    ).then((res) => {
      localStorage.setItem(
        "product_inquiry",
        JSON.stringify(res?.payload?.productInquiry)
      );
    });
    // } else
    if (
      productDetails &&
      productDetails?.product_id === 1 &&
      (productDetails?.sub_product_id === 1 ||
        productDetails?.sub_product_id === 21)
    ) {
      let currentVehicleData = vehicleData;
      if (productDetails?.sub_product_id === 1) {
        //for thirdparty fetch vehicle details
        const newVehicleData = await getVehicleDetailFromROP();
        if (!newVehicleData) return;
        currentVehicleData = newVehicleData;
      }

      let startInputDate = getExcelDate();
      if (formData && formData.no_of_persons) {
        setAskMemberDetailForm(true);
      } else {

        //For takaful motor prepare inputs data
        let takafulInputsParameter = prepareTakafulMotorPremiumCalInputs(
          currentVehicleData,
          formData
        );
        let claimDetails = getClaimDetails(currentVehicleData);
        let oqicInsuranceData = prepareOqicQuoteData(
          currentVehicleData,
          formData
        );

        let vehicleInformation = setVehicleInformation(currentVehicleData);
        setFirstTime(false);



        const validationFlags = computeVehicleValidationFlags(
          currentVehicleData,
          selectedProduct
        );
        if (
          currentVehicleData &&
          !validationFlags?.licenceExpired &&
          !validationFlags?.previousInsuranceExpired &&
          !validationFlags?.policyHas60Days
        ) {

          const vehicleInfo = vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo;

          dispatch(
            addTransactionData({
              product_id: productDetails?.product_id,
              sub_product: productDetails?.sub_product_id,
              business_status: "QUOTE",
              mobile_no: formData.mobile_no,
            })
          )
          navigate("/get-quotes", {
            state: {
              ropRequestData: {
                form_data: {
                  ...formData,
                  takafulInputsParameter,
                  ...takafulInputsParameter,
                  ...claimDetails,
                  ...vehicleInformation,
                  sport_activity_loading: "No",
                  nil_excess_loading: "No",
                  top_up_benefits_loading: "No",
                  prev_policy_exp_date: getExcelDate(
                    formData?.prev_policy_exp_date
                  ),
                  policy_start_input_date: startInputDate,
                  start_excel_date: getExcelDate(formData?.start_date),
                  end_excel_date: getExcelDate(formData?.end_date),
                  dob_excel_date: getExcelDate(formData?.date_of_birth),
                  today_iso_date: getISOFormattedDate(),
                  yesterday_iso_date: getISOFormattedDate(-1),
                  tomorrow_iso_date: getISOFormattedDate(1),
                  a_day_before_iso_date: getISOFormattedDate(-2),
                  a_day_after_iso_date: getISOFormattedDate(2),
                  five_day_after_iso_date: getISOFormattedDate(5),
                  gig_expiry_date: getISOFormattedDate(365),
                  policyHolderDrivingExperience: getYearDifferenceFromToday(
                    vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
                      ?.GetLicenseInfoResult?.DateFirstIssued
                  ),
                  launguage: currentLanguage === "ar" ? "AR" : "ENG",
                  ...oqicInsuranceData,
                },
                product_details: JSON.parse(
                  localStorage.getItem("product_details")
                ),
                product,
              },
              vehicleData: vehicleData ?? currentVehicleData,
              valuationData: formData?.vehicle_valuation || 0,
            },
          });
        } else {
          // console.error(
          //   "Either License Expired or Previous Inurance expired or Policy has 60 days so user will no go ahead."
          // );
          // optionally you can set the component states so UI alerts show:
          setPreviousInsuranceExpired(validationFlags?.previousInsuranceExpired);
          setLicenceExpired(validationFlags?.licenceExpired);
          setPolicyHas60Days(validationFlags.policyHas60Days || true);
        }
      }
    } else if (
      productDetails &&
      productDetails?.product_id === 15 &&
      productDetails?.sub_product_id === 20
    ) {
      // call only while travel product selected

      let startInputDate = getExcelDate();

      if (productDetail?.has_company === false) {
        dispatch(
          createProductInquiry({
            form_data: formData,
            product_details: JSON.parse(
              localStorage.getItem("product_details")
            ),
          })
        );
      } else {
        if (formData && formData.no_of_persons) {
          setAskMemberDetailForm(true);
        } else {
          if (
            !(
              formData?.["no_of_adults_-_(age_18_or_above)"] != null &&
              formData?.["no_of_adults_-_(age_18_or_above)"] != ""
            )
          ) {
            formData["no_of_adults_-_(age_18_or_above)"] = 0;
          }
          if (
            !(
              formData?.["no_of_child_-_(age_16_or_below)"] != null &&
              formData?.["no_of_child_-_(age_16_or_below)"] != ""
            )
          ) {
            formData["no_of_child_-_(age_16_or_below)"] = 0;
          }

          if (
            !(
              formData?.["no_of_child_-_(age_17_to_18)"] != null &&
              formData?.["no_of_child_-_(age_17_to_18)"] != ""
            )
          ) {
            formData["no_of_child_-_(age_17_to_18)"] = 0;
          }

          if (
            !(
              formData?.["no_of_seniors_-_(age_71_to_79)"] != null &&
              formData?.["no_of_seniors_-_(age_71_to_79)"] != ""
            )
          ) {
            formData["no_of_seniors_-_(age_71_to_79)"] = 0;
          }

          let total_persons =
            parseInt(formData["no_of_adults_-_(age_18_or_above)"]) +
            parseInt(formData["no_of_child_-_(age_16_or_below)"]) +
            parseInt(formData["no_of_child_-_(age_17_to_18)"]) +
            parseInt(formData["no_of_seniors_-_(age_71_to_79)"]);

          //For Takaful travel preapare member_details data
          let mem_details =
            total_persons > 1
              ? createTakafulPeopleArrayFromGroups([
                {
                  count: parseInt(
                    formData["no_of_adults_-_(age_18_or_above)"]
                  ),
                  age: 18,
                },
                {
                  count: parseInt(
                    formData["no_of_child_-_(age_16_or_below)"]
                  ),
                  age: 16,
                },
                {
                  count: parseInt(formData["no_of_child_-_(age_17_to_18)"]),
                  age: 17,
                },
                {
                  count: parseInt(formData["no_of_seniors_-_(age_71_to_79)"]),
                  age: 71,
                },
              ])
              : [];

          //For GIG travel preapare insuredMembers data
          let insuredMembers = createPeopleArrayFromGroups([
            {
              count: parseInt(formData["no_of_adults_-_(age_18_or_above)"]),
              age: 18,
            },
            {
              count: parseInt(formData["no_of_child_-_(age_16_or_below)"]),
              age: 16,
            },
            {
              count: parseInt(formData["no_of_child_-_(age_17_to_18)"]),
              age: 17,
            },
            {
              count: parseInt(formData["no_of_seniors_-_(age_71_to_79)"]),
              age: 65, // For GIG Inusrance Age Range is 65-69
            },
          ]);

          let gig_area_of_coverage = "";
          if (travelProductType && travelProductType?.length) {
            gig_area_of_coverage = {
              code: travelProductType[0]?.values[4],
              value: travelProductType[0]?.user_options,
            };
          }

          //for arab oriene get country
          let ao_nationality = "";
          dispatch(
            getAoMasterData({
              launguage: currentLanguage === "ar" ? "AR" : "ENG",
              typeCode: "02",
            })
          ).then((res) => {
            ao_nationality = res?.payload?.data?.find(
              (item) => item?.text === countryDetails?.name
            )?.code;


            dispatch(
              addTransactionData({
                product_id: productDetails?.product_id,
                sub_product: productDetails?.sub_product_id,
                business_status: "QUOTE",
                mobile_no: formData.mobile_no,
                travel_from: 'OMAN',
                travel_to: countryDetails?.name,
              })
            )

            navigate("/get-quotes", {
              state: {
                ropRequestData: {
                  form_data: {
                    ...formData,
                    policy_type: total_persons > 1 ? "Group" : "Individual",
                    sport_activity_loading: "No",
                    nil_excess_loading: "No",
                    top_up_benefits_loading: "No",
                    mem_details: mem_details,
                    prev_policy_exp_date: getExcelDate(
                      formData?.prev_policy_exp_date
                    ),
                    policy_start_input_date: startInputDate,
                    start_excel_date: getExcelDate(formData?.start_date),
                    end_excel_date: getExcelDate(formData?.end_date),
                    dob_excel_date: getExcelDate(formData?.date_of_birth),
                    today_iso_date: getISOFormattedDate(),
                    yesterday_iso_date: getISOFormattedDate(-1),
                    tomorrow_iso_date: getISOFormattedDate(1),
                    a_day_before_iso_date: getISOFormattedDate(-2),
                    a_day_after_iso_date: getISOFormattedDate(2),
                    five_day_after_iso_date: getISOFormattedDate(5),
                    destination:
                      countryDetails && countryDetails?.name
                        ? countryDetails?.name.toUpperCase()
                        : "",
                    insuredMembers,
                    destinationCountries: [
                      {
                        code: countryDetails?.short_code,
                        value: countryDetails?.name,
                      },
                    ],
                    travel_product_type:
                      travelProductType && travelProductType?.length
                        ? travelProductType[0]?.values
                        : "",
                    gig_area_of_coverage,
                    arab_oriene_start_date: formatToDDMMYYYY(
                      formData?.start_date
                    ),
                    arab_oriene_end_date: formatToDDMMYYYY(formData?.end_date),
                    no_of_days: getDaysDiff(
                      formData?.start_date,
                      formData?.end_date
                    ),
                    gig_expiry_date: getISOFormattedDate(365),
                    total_adults:
                      parseInt(formData["no_of_adults_-_(age_18_or_above)"]) +
                      parseInt(formData["no_of_seniors_-_(age_71_to_79)"]),
                    total_children:
                      parseInt(formData["no_of_child_-_(age_16_or_below)"]) +
                      parseInt(formData["no_of_child_-_(age_17_to_18)"]),
                    launguage: currentLanguage === "ar" ? "AR" : "ENG",
                    ao_nationality,
                    ao_insurance_destination_country:
                      travelProductType && travelProductType?.length
                        ? travelProductType[0]?.values["5"]
                        : "",
                  },
                  product_details: JSON.parse(
                    localStorage.getItem("product_details")
                  ),
                  product,
                },
                vehicleData,
              },
            });
          });
          //for arab oriene get country code
        }
      }
    } else {
      console.error("No product configuration found");
    }
  };

  const handleInputChange = (name, value, item) => {
    if (name === "destination") {
      dispatch(getCountryDetail(value));
    } else if (name === "area_of_coverage") {
      dispatch(getTravelProductType(value));
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (name === "admeid") {
      const selectedVehicle = vehicleData?.ropVehicle?.Body
        ?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult
        ?.result?.vehicle_description?.Vehicle_Description?.length
        ? vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.result?.vehicle_description?.Vehicle_Description.find(
          (item) => item?.admeid === value
        )
        : null;

      setSelectedVehicleDescription(selectedVehicle);
      setFormData({
        ...formData,
        vehicle_valuation: selectedVehicle?.trade_price,
      });
    } else {

      //    const validationErrors = validateForm();

      //    console.log('lh',validationErrors);


      // if (Object.keys(validationErrors).length > 0) {
      //   setErrors(validationErrors);
      //   console.log('errors',errors);
      //   return;
      // }else{
      //   setErrors({});
      // }
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      // Clear error for this field when user types
      if (errors[name]) {
        setErrors((prev) => {
          const { [name]: _, ...rest } = prev;
          return rest;
        });
      }
    }
  };

  const handleAskMemberDetailFormSubmit = (e, displayFormData) => {
    e.preventDefault();
    let startInputDate = getExcelDate();
    //For GIG Travel preapare insuredMembers data
    let insuredMembers = [];
    if (displayFormData && displayFormData.length > 0) {
      displayFormData.forEach((item) => {
        insuredMembers.push({
          person: {
            birthDate: item?.member_dob,
            gender: {
              code: item?.member_gender.charAt(0),
              value: item?.member_gender,
            },
          },
        });
      });
    }

    navigate("/get-quotes", {
      state: {
        ropRequestData: {
          form_data: {
            ...formData,
            mem_details: displayFormData,
            prev_policy_exp_date: startInputDate - 1,
            policy_start_input_date: startInputDate,
            start_excel_date: getExcelDate(formData?.start_date),
            end_excel_date: getExcelDate(formData?.end_date),
            dob_excel_date: getExcelDate(formData?.date_of_birth),
            today_iso_date: getISOFormattedDate(),
            yesterday_iso_date: getISOFormattedDate(-1),
            tomorrow_iso_date: getISOFormattedDate(1),
            a_day_before_iso_date: getISOFormattedDate(-2),
            a_day_after_iso_date: getISOFormattedDate(2),
            five_day_after_iso_date: getISOFormattedDate(5),
            destination:
              countryDetails && countryDetails?.name
                ? countryDetails?.name?.toUpperCase()
                : "",
            insuredMembers,
            destinationCountries: [
              {
                code: countryDetails?.short_code,
                value: countryDetails?.name,
              },
            ],
            travel_product_type:
              travelProductType && travelProductType?.length
                ? travelProductType[0]?.values
                : "",
          },
          product_details: JSON.parse(localStorage.getItem("product_details")),
          product,
        },
        vehicleData,
      },
    });
    setAskMemberDetailForm(false);
  };

  useEffect(() => {
    if (productInquiry) {
      console.log("productInquiry", productInquiry);
      debugger;
    }
  }, [productInquiryLoader, productInquiry]);

  const handleRangeChange = ({ name, range }) => {
    setFormData({
      ...formData,
      [name]: range,
      start_date: range.startDate,
      end_date: range.endDate,
    });
  };

  //  const getVehicleDetailFromROP = async () => {
  //     // call only while motor product selected
  //     if (!isNaN(formData?.plate_char)) {
  //       const res = await dispatch(getPlateTypeDetails(formData?.plate_char));
  //       if (res?.payload?.data?.length) {
  //         formData.plate_type = res?.payload?.data[0]?.plate_code;
  //         formData.plate_char = res?.payload?.data[0]?.plate_char_en;
  //       }
  //     }
  //     const vehicleDetailsAction = await dispatch(
  //       getLicenseVehicle({ ...formData })
  //     );
  //     console.log("vehicle data to send", vehicleDetailsAction.payload);

  //     return vehicleDetailsAction.payload;
  //   };

  const getVehicleDetailFromROP = async () => {
    // call only while motor product selected
    setLoadingVehicleSection(true);
    var plateCode, plateChar;
    if (!isNaN(formData?.plate_char)) {
      const res = await dispatch(getPlateTypeDetails(formData?.plate_char));
      if (res?.payload?.data?.length) {
        // formData.plate_type = res?.payload?.data[0]?.plate_code;
        // formData.plate_char = res?.payload?.data[0]?.plate_char_en;
        plateCode = res?.payload?.data[0]?.plate_code
        plateChar = res?.payload?.data[0]?.plate_char_en
      }
    }
    let vehicleDetailsAction;
    try {
      vehicleDetailsAction = await dispatch(
        getLicenseVehicle({
          ...formData, ...{
            plate_type: plateCode,
            plate_char: plateChar
          }
        })
      );
    } catch (error) {
      setLoadingVehicleSection(false);
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.serviceUnavailableTitle", { defaultValue: "Service Unavailable" }),
        description: 'We are unable to fetch your vehicle details currently. Please try later',
      });
      return null;
    }

    if (!vehicleDetailsAction?.payload) {
      setLoadingVehicleSection(false);
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.serviceUnavailableTitle", { defaultValue: "Service Unavailable" }),
        description: 'We are unable to fetch your vehicle details currently. Please try later',
      });
      return null;
    }

    const licenseResult = vehicleDetailsAction?.payload?.ropLicense?.Body?.GetLicenseInfoResponse?.GetLicenseInfoResult;

    if (licenseResult?.ErrorCode && licenseResult.ErrorCode !== "E0000") {
      setLoadingVehicleSection(false);
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.licenseErrorTitle", { defaultValue: "License Error" }),
        description: 'License Details cannot be found. Please check the license number and try again' || t("validationMessages.licenseErrorDescription", { defaultValue: "Unable to fetch license information. Please check the license number and try again." }),
      });
      return null;
    }

    const vehicleResult = vehicleDetailsAction?.payload?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult;

    if (vehicleResult?.errorCode && vehicleResult.errorCode !== "EV000") {
      setLoadingVehicleSection(false);
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.vehicleErrorTitle", { defaultValue: "Vehicle Error" }),
        description: 'Vehicle Details cannot be found. Please re-check the Plate number and Plate Char and try again' || t("validationMessages.vehicleErrorDescription", { defaultValue: "Unable to fetch vehicle information. Please check the plate number and try again." }),
      });
      return null;
    }

    setLoadingVehicleSection(false);
    return vehicleDetailsAction.payload;
  };







  useEffect(() => {
    if (vehicleData) {
      // Skip validations if license has an error
      const licenseErrorCode = vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse?.GetLicenseInfoResult?.ErrorCode;
      if (licenseErrorCode && licenseErrorCode !== "E0000") return;

      const vehicleInfo =
        vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
          ?.GetVehicleValuationByPlateResult?.VehicleInfo;
      // console.log("DJ:: vehicleInfo:: ", vehicleInfo);
      //case 1:: Previous Insurance Expired and want to buy comprehensive policy
      if (vehicleInfo?.InsuranceEndDate) {
        const isInsuranceEndDatePast = isTodayOrPast(
          vehicleInfo?.InsuranceEndDate
        );
        setPreviousInsuranceExpired(isInsuranceEndDatePast);

        const today = new Date();

        // Parse "20250518" into a Date object
        const targetDate = parse(
          vehicleInfo?.InsuranceEndDate,
          "yyyyMMdd",
          new Date()
        );
        // console.log("targetDate:: ", targetDate);

        // Calculate difference
        const diff = differenceInDays(targetDate, today);
        // console.log("Diff:: ", diff);

        if (diff > 60) {
          setPolicyHas60Days(true);
        }
      }
      //case 2:: Vehicle Age > 7 and want to by comprehensive policy
      if (
        selectedProduct?.product_id === 1 &&
        selectedProduct?.sub_product_id === 21 &&
        new Date().getFullYear() - parseInt(vehicleInfo?.MakeYear) > 7
      ) {
        setVehicleAgeLimitExpired(true);
      }
      // case 3:: previous policy is Third pary and want to by compreshensive policy
      if (
        selectedProduct?.product_id === 1 &&
        selectedProduct?.sub_product_id === 21 &&
        vehicleInfo?.InsuranceTypeDesc.toLowerCase().includes("third")
      ) {
        setPreviousThirdPartyInsurance(true);
      }
      //case 4::entered Licence No is Expired and want to buy comprehensive policy
      // console.log("DJ:: vehicleData::", { vehicleData });
      const licenceInfo =
        vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
          ?.GetLicenseInfoResult;
      if (licenceInfo?.DateofExpiry) {
        const isLicenceExpired = isTodayOrPast(licenceInfo?.DateofExpiry);
        setLicenceExpired(isLicenceExpired);
      }
    }

    if (
      vehicleData &&
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.result?.vin_decoding
    ) {
      let selectedAmeid =
        vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
          ?.GetVehicleValuationByPlateResult?.result?.vin_decoding?.admeid;
      let selectedVehicleDescription =
        vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
          ?.GetVehicleValuationByPlateResult?.result?.vehicle_description
          ?.Vehicle_Description;

      let selectedVehicle;
      if (Array.isArray(selectedVehicleDescription)) {
        selectedVehicle = selectedVehicleDescription?.find(
          (item) => item?.admeid === selectedAmeid
        );
      } else {
        selectedVehicle = selectedVehicleDescription;
      }



      setSelectedVehicleDescription(selectedVehicle);
      setFormData({
        ...formData,
        admeid: selectedAmeid,
        vehicle_valuation: selectedVehicle?.trade_price,
      });
    }
  }, [vehicleData]);

  useEffect(() => {
    if (previousInsuranceExpired) {
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.previousInsuranceExpiredTitle"),
        description: t(
          "validationMessages.previousInsuranceExpiredDescription"
        ),
      });
    }
  }, [vehicleData, previousInsuranceExpired]);

  useEffect(() => {
    if (licenceExpired) {
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.licenceExpiredTitle"),
        description: t("validationMessages.licenceExpiredDescription"),
      });
    }
  }, [vehicleData, licenceExpired]);

  useEffect(() => {
    if (previousThirdPartyInsurance) {
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.previousThirdPartyInsuranceTitle"),
        description: t(
          "validationMessages.previousThirdPartyInsuranceDescription"
        ),
      });
    }
  }, [vehicleData, previousThirdPartyInsurance]);

  useEffect(() => {
    if (vehicleAgeLimitExpired) {
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.vehicleAgeTitle"),
        description: t("validationMessages.vehicleAgeDescription"),
      });
    }
  }, [vehicleData, vehicleAgeLimitExpired]);


  useEffect(() => {
    if (disableSenior && seniors > 0) {
      setFormData(prev => ({
        ...prev,
        ["no_of_seniors_-_(age_71_to_79)"]: 0
      }));
    }

    if (disableAdultsAndChildren && (adults > 0 || children > 0)) {
      setFormData(prev => ({
        ...prev,
        ["no_of_adults_-_(age_18_or_above)"]: 0,
        ["no_of_child_-_(age_16_or_below)"]: 0
      }));
    }
  }, [disableSenior, disableAdultsAndChildren]);



  useEffect(() => {
    if (policyHas60Days) {
      setShowValidationAlert(true);
      setAlertMessage({
        title: t("validationMessages.policyHas60DaysTitle"),
        description: t("validationMessages.policyHas60DaysDescription"),
      });
    }
  }, [vehicleData, policyHas60Days]);

  if (
    productLoader ||
    productDetailLoader ||
    aoMasterDataLoader
  ) {
    return <Loader type="logo-gif" />;
  }


  const validateForm = () => {
    const newErrors = {};

    if (formData?.["no_of_adults_-_(age_18_or_above)"] > 0 && formData?.['no_of_seniors_-_(age_71_to_79)'] > 0) {
      newErrors["no_of_adults_-_(age_18_or_above)"] = 'Either Adult or Senior Citizen must be included';
      newErrors["no_of_seniors_-_(age_71_to_79)"] = 'Either Adult or Senior Citizen must be included';
    }

    if (formData?.["no_of_child_-_(age_16_or_below)"] > 0 && formData?.['no_of_seniors_-_(age_71_to_79)'] > 0) {
      newErrors["no_of_child_-_(age_16_or_below)"] = 'Either Child or Senior Citizen must be included';
      newErrors["no_of_seniors_-_(age_71_to_79)"] = 'Either Child or Senior Citizen must be included';
    }

    if (formData.email) {
      const email = formData.email.trim();
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        newErrors.email = t("validation.email_invalid");
      }
    }

    return newErrors;
  };

  const newLocal = "policy-formBox why-us-form";
  return (
    <>
      <Container fluid >

        <Row className="align-items-stretch">
          {product?.id === 1 && (
            <Col style={{ backgroundColor: "#F1F2F4" }} lg={7} className={`${isArabic ? "pe-4 ps-0" : "ps-4"}`}>
              <Row className={`align-items-center hero-section text-center ${isArabic ? "g-0 p-0" : "ps-4"}`}>

                {/* LEFT CONTENT */}
                <Col xs={12} lg={6} className="hero-content mb-4 mb-lg-0">
                  <h1 className="hero-title">
                    {t("motorInsuranceTitle")}
                  </h1>

                  <p className="hero-subtitle">
                    {t("motorInsuranceSubtitle")}
                  </p>

                  <div className="hero-features">
                    <div className="feature-item">
                      <span className="gold-box"></span>
                      {t("instantQuoteComparison")}
                    </div>

                    <div className="feature-item">
                      <span className="gold-box"></span>
                      {t("fastEasyPolicyIssuance")}
                    </div>

                    <div className="feature-item">
                      <span className="gold-box"></span>
                      {t("seamlessClaimsSupport")}
                    </div>
                  </div>
                </Col>

                {/* RIGHT IMAGE */}
                <Col xs={12} lg={6} className="p-0">
                  <img
                    src={heroImage}
                    alt="Motor Insurance"
                    className="img-fluid hero-img"
                  />
                </Col>

              </Row>
            </Col>
          )}
          {product?.id === 15 && (
            <Col style={{ backgroundColor: "#E9E9E9" }} lg={6} className="ps-4 travel-image-back">
              <Row
                className={`align-items-center align-centent-center hero-section ps-4 ms-1  ${isArabic ? "pe-4" : "ps-4"}`}
              >
                {/* LEFT CONTENT */}
                <Col lg={7} className="hero-content">
                  <h1 className="hero-title">
                    {t("travelInsuranceTitle")}
                  </h1>

                  <p className="hero-subtitle">
                    {t("travel_ins")}
                  </p>

                  <div className="hero-features">
                    <div className="feature-item">
                      <span className="gold-box"></span>
                      {t("instantQuoteComparison")}
                    </div>

                    <div className="feature-item">
                      <span className="gold-box"></span>
                      {t("fastEasyPolicyIssuance")}
                    </div>

                    <div className="feature-item">
                      <span className="gold-box"></span>
                      {t("seamlessClaimsSupport")}
                    </div>
                  </div>
                </Col>

                {/* RIGHT IMAGE */}
                <Col lg={5} className="hero-image text-end">
                  <img
                    src={travelMain}
                    alt="Travel Insurance"
                    className="img-fluid hero-img"
                    style={{ width: "100%", height: "auto" }}

                  />
                </Col>
              </Row>
            </Col>
          )}
          <Col lg={product?.id === 15 ? 6 : 5} className="align-content-center">
            <div className="insurance-title">
              <h3 className="title text-capitalize text-center mb-2 form-title-header">
                {product?.id == 1 && currentLanguage === "ar" ? 'عروض تأمين السيارات/ المركبات' : product?.id == 15 && currentLanguage === "ar" ? "احصل على اسعار تأمين السفر" : t("getQuoteTitle", {
                  product_name:
                    currentLanguage === "ar"
                      ? product?.product_name_ar
                      : product?.product_name,
                })}
              </h3>
            </div>
            <Col>
              <div className="policy-form">
                <div className={newLocal}>
                  <Form onSubmit={submitGetQuote}>
                    <div className="formbtn active-btn">
                      {subProducts &&
                        subProducts.length > 0 &&
                        subProducts.map((subProduct, index) => (
                          <Button
                            key={`subProduct_${index}`}
                            className={
                              "btn h-btn mb-3" +
                              (activeSubProduct === index ? " active" : "")
                            }
                            onClick={() =>
                              handleSubProductClick(
                                {
                                  product_id: subProduct?.product_id,
                                  sub_product_id: subProduct?.id,
                                },
                                index
                              )
                            }
                          >
                            {currentLanguage === "ar"
                              ? productDetails && productDetails?.product_id === 15 ? 'السفر' :
                                productDetails?.product_id === 15 &&
                                  productDetails?.sub_product_id === 20 && currentLanguage == 'ar' ? "تأمين السفر" : subProduct?.sub_product_name_ar
                              : subProduct?.sub_product_name}
                          </Button>
                        ))}
                    </div>

                    {productDetail?.place_to_call === "1" && (
                      <>
                        <div className="form-style">
                          {productDetail.input_paremeter.map((item, index) => {
                            const isSeniorField = item.input_label.includes("Seniors");
                            const isAdultField = item.input_label.includes("Adults") && item.input_label.includes("18 or Above");
                            const isChildField = item.input_label.includes("Child");

                            // Determine if field should be disabled
                            let isDisabledField = false;
                            if (isSeniorField) {
                              // Senior field disabled if ANY adults or children are present
                              isDisabledField = adults > 0 || children > 0;
                            } else if (isAdultField || isChildField) {
                              // Adult/Child fields disabled if ANY seniors are present
                              isDisabledField = seniors > 0;
                            }

                            return (
                              <div
                                className={
                                  item?.input_type === "radio"
                                    ? "form-group custom-checkbox"
                                    : "form-group"
                                }
                                key={"motor_page_input_parameters_" + index}
                              >
                                <ProductParameterForm
                                  formData={formData}
                                  handleInputChange={handleInputChange}
                                  handleRangeChange={handleRangeChange}
                                  item={item}
                                  disabled={isDisabledField}
                                  currentLanguage={currentLanguage}
                                  errorMessages={errors}
                                />
                              </div>
                            );
                          })}
                        </div>
                        {selectedProduct?.product_id === 15 &&
                          selectedProduct?.sub_product_id === 20 ? (
                          <div className="form-note mb-2">
                            <h4>{t("formNote.disclaimer")}</h4>
                            <p>{t("formNote.note")}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="formbtn justify-content-end">
                          {selectedProduct?.product_id === 1 &&
                            selectedProduct?.sub_product_id === 21 ? (
                            <>
                              <button
                                type="button"
                                className="btn h-btn my-3"
                                onClick={getVehicleDetailFromROP}
                                disabled={loadingVehicleSection}
                              >
                                {loadingVehicleSection
                                  ? t("loading")
                                  : t("vehicleDetailsBtnTxt")}
                              </button>
                              {/* 
                              {loadingVehicleSection && (
                                <div className="mt-3">
                                  <Loader type="spinner" />
                                </div>
                              )} */}
                            </>
                          ) : (
                            <button type="submit" className="btn h-btn my-3">
                              {t("quoteBtnTxt")}
                            </button>
                          )}
                        </div>

                      </>
                    )}

                    {showVehicleSection &&
                      selectedProduct?.product_id === 1 &&
                      selectedProduct?.sub_product_id === 21 &&
                      !previousInsuranceExpired &&
                      !licenceExpired &&
                      !vehicleAgeLimitExpired &&
                      !policyHas60Days &&
                      !previousThirdPartyInsurance && (
                        <VehicleValuationForm
                          vehicleDescriptionData={
                            vehicleData?.ropVehicle?.Body
                              ?.GetVehicleValuationByPlateResponse
                              ?.GetVehicleValuationByPlateResult
                              ?.result
                              ?.vehicle_description
                              ?.Vehicle_Description
                          }
                          selectedVehicleDescription={selectedVehicleDescription}
                          handleInputChange={handleInputChange}
                          formData={formData}
                        />
                      )}



                    {productDetail?.place_to_call === "0" && (
                      <NoData msg={t("noInputParameterFound")} />
                    )}
                  </Form>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      </Container>
      <DynamicFormModal
        show={askMemberDetailForm}
        handleClose={setAskMemberDetailForm}
        handleSubmit={handleAskMemberDetailFormSubmit}
        inputParameters={askMemberDetailFormData}
        noOfData={parseInt(formData.no_of_persons)}
      />
      <AlertDialog
        show={showValidationAlert}
        title={alertMessage.title}
        message={alertMessage.description}
        onConfirm={() => {
          dispatch(resetVehicleData());
          setPreviousInsuranceExpired(false);
          setLicenceExpired(false);
          setVehicleAgeLimitExpired(false);
          setPolicyHas60Days(false);
          setPreviousThirdPartyInsurance(false);
          setShowValidationAlert(false);
        }}
        onCancel={() => {
          dispatch(resetVehicleData());
          setPreviousInsuranceExpired(false);
          setLicenceExpired(false);
          setVehicleAgeLimitExpired(false);
          setPolicyHas60Days(false);
          setPreviousThirdPartyInsurance(false);
          setShowValidationAlert(false);
        }}
      />
    </>
  );
};

export default MotorPage;
